import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

// modal wrapper styled component
const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
`;

// modal content styled component
const ModalContent = styled.div`
  background-color: white;
  border-radius: 5px;
  overflow: hidden;
  /* width: 90vw; */
  width: 200px;
  /* height: 50px; */
  padding: 30px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  .modal-body {
    width: 100%;
    /* height: 50px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .modal-top {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .modal-close {
    cursor: pointer;
  }

  @media (max-width: 748px) {
    width: 90vw;
    height: fit-content;
  }
`;

interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
  open: boolean;
}

const usePreventScroll = (isPrevent : boolean) => {
  useEffect(() => {
    if (isPrevent) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isPrevent]);
  
};

export function Modal2({ children, onClose, open }: ModalProps) {
  const [isOpen, setIsOpen] = useState(false);
  usePreventScroll(isOpen)

  useEffect(() => {
    if (open) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [open]);

  const closeOnEscapeKeyDown = (e: KeyboardEvent) => {
    if ((e.charCode || e.keyCode) === 27) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return () => {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  });

  const modalContent = isOpen
    ? createPortal(
        <ModalWrapper
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              onClose();
            }
          }}
        >
          <ModalContent>
            <div className="modal-body">{children}</div>
            <div className="modal-top">
              <div className="modal-close" onClick={onClose}>
                <img
                  src="/close.svg"
                  alt="close"
                  style={{ width: "16px", height: "16px", display: "block" }}
                />
              </div>
            </div>
          </ModalContent>
        </ModalWrapper>,
        document.getElementById("modal-root") as HTMLElement
      )
    : null;

  return modalContent;
}
